/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductGroupDto } from '../../models/backend-product-group-dto';

export interface SalesGroupsRetrieve$Params {
  /**
   * A unique integer value identifying this product group.
   */
  id: number;
}

export function salesGroupsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: SalesGroupsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductGroupDto>> {
  const rb = new RequestBuilder(rootUrl, salesGroupsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductGroupDto>;
    }),
  );
}

salesGroupsRetrieve.PATH = '/api/sales/groups/{id}/';
